import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Typography} from '@mui/material';

const ThankYouModal = ({ open, onClose, onConfirm, thankYouText}) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="thank-you-dialog" BackdropProps={{style: { backgroundColor: 'transparent' }}}>
      <DialogTitle id="thank-you-dialog">{thankYouText}</DialogTitle>
      <DialogActions>
        <Button onClick={()=>onConfirm()} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ThankYouModal;
